// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1522":"dc6e8ea562b720b5","7734":"bb6bf75d3312251b"}[chunkId] + ".js";
};